import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import { Modal } from '@sunwebgroup/ui-components'
import { useEffect } from 'react'
import { ExtendedContent } from './ExtendedContent'

interface ExtendedProps {
  showModal: boolean
  closeModal: () => void
}

export function Extended({ showModal, closeModal }: ExtendedProps) {
  const { sendEvent } = useAnalytics()

  useEffect(() => {
    if (showModal) {
      sendEvent(
        createPDPClickEvent({
          element: 'Modal',
          description: 'Show more information about the reviews',
          result: 'Modal with all reviews opened',
          type: 'Reviews extended modal',
        }),
      )
    }
  }, [sendEvent, showModal])

  const handleModalClose = () => {
    closeModal()
    sendEvent(
      createPDPClickEvent({
        element: 'Modal',
        description: 'Hide information about the reviews',
        result: 'Modal with all reviews closed',
        type: 'Reviews extended modal',
      }),
    )
  }

  const intl = useIntl()
  return (
    <Modal.Root open={showModal} onClose={handleModalClose}>
      <Modal.Content $size="xl">
        <Modal.Header>
          <Modal.HeaderTitle text={intl.formatMessage({ id: 'reviews_extended_heading' })} />
          <Modal.HeaderCloseButton />
        </Modal.Header>
        <Modal.Body>
          <ExtendedContent />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  )
}
